import {
  GetterTree, Module, MutationTree, ActionTree,
} from 'vuex'

export interface VisualState {
  isDark: boolean
  headerElementsAsList: boolean;
  hideStartPageGraphs: boolean;
  primaryColor: string
  backgroundColor: string
  artistHeaderBackground: string
  artistProfileBackground: string
  supportHeaderBackground: string
  supportProfileBackground: string
  userHeaderBackground: string
  userProfileBackground: string
  ownHeaderBackground: string
  ownProfileBackground: string
  headerImageUrl: string
  logoImageUrl: string
  radioImageUrl: string
  phoneImageUrl: string
  musicImageUrl: string
  font: string
  buttonTextColor: string
  stickerBackground: string
  stickersSelected: string[]
}

const translationState: VisualState = {
  isDark: false,
  headerElementsAsList: false,
  hideStartPageGraphs: false,
  primaryColor: '#F4E48D',
  backgroundColor: '#F4F2E8',
  artistHeaderBackground: '#F4E48D',
  artistProfileBackground: '#fff',
  supportHeaderBackground: '#E9E9E9',
  supportProfileBackground: '#fff',
  userHeaderBackground: '#E9E9E9',
  userProfileBackground: '#F4F2E8',
  ownHeaderBackground: 'rgba(255, 255, 255, 0.8)',
  ownProfileBackground: '#F4E48D',
  headerImageUrl: 'https://dev.backend.universalmusic.digital/media/rectangle-16.png',
  logoImageUrl: 'https://dev.backend.universalmusic.digital/media/lana-logo-1.png',
  musicImageUrl: 'https://dev.backend.universalmusic.digital/media/packshot-1.jpg',
  radioImageUrl: '',
  phoneImageUrl: '',
  font: 'rubik',
  buttonTextColor: '#263451',
  stickerBackground: '#000000CC',
  stickersSelected: [
    'wow',
    'tape',
    'star-glasses',
    'so-sad',
    'smily-stars',
    'rock_on',
    'peace-hand',
    'music_hearts',
    'love-it',
    'lips',
    'heart-rainbow',
    'hand-hang-loose',
    'guitars',
    'glasses-thunder',
    'glasses-striped',
    'glasses-heart',
    'flame',
    'emoji-love',
    'emoji-cry',
    'discoball-v5',
    'dancer-woman',
    'dance-man',
    'confetti',
    'boom',
  ]
}

const mutations: MutationTree<VisualState> = {
  SET_VISUAL_IS_DARK(state: VisualState, isDark) {
    state.isDark = isDark
  },
  SET_VISUAL_PRIMARY_COLOR(state: VisualState, primaryColor) {
    state.primaryColor = primaryColor
  },
  SET_VISUAL_BACKGROUND_COLOR(state: VisualState, backgroundColor) {
    state.backgroundColor = backgroundColor
  },
  SET_VISUAL_ARIST_HEADER_BACKGROUND(state: VisualState, artistHeaderBackground) {
    state.artistHeaderBackground = artistHeaderBackground
  },
  SET_VISUAL_ARIST_PROFILE_BACKGROUND(state: VisualState, artistProfileBackground) {
    state.artistProfileBackground = artistProfileBackground
  },
  SET_VISUAL_SUPPORT_HEADER_BACKGROUND(state: VisualState, supportHeaderBackground) {
    state.supportHeaderBackground = supportHeaderBackground
  },
  SET_VISUAL_SUPPORT_PROFILE_BACKGROUND(state: VisualState, supportProfileBackground) {
    state.supportProfileBackground = supportProfileBackground
  },
  SET_VISUAL_USER_HEADER_BACKGROUND(state: VisualState, userHeaderBackground) {
    state.userHeaderBackground = userHeaderBackground
  },
  SET_VISUAL_USER_PROFILE_BACKGROUND(state: VisualState, userProfileBackground) {
    state.userProfileBackground = userProfileBackground
  },
  SET_VISUAL_OWN_HEADER_BACKGROUND(state: VisualState, ownHeaderBackground) {
    state.ownHeaderBackground = ownHeaderBackground
  },
  SET_VISUAL_OWN_PROFILE_BACKGROUND(state: VisualState, ownProfileBackground) {
    state.ownProfileBackground = ownProfileBackground
  },
  SET_VISUAL_HEADER_IMAGE_URL(state: VisualState, headerImageUrl) {
    state.headerImageUrl = headerImageUrl
  },
  SET_VISUAL_LOGO_IMAGE_URL(state: VisualState, logoImageUrl) {
    state.logoImageUrl = logoImageUrl
  },
  SET_VISUAL_RADIO_IMAGE_URL(state: VisualState, radioImageUrl) {
    state.radioImageUrl = radioImageUrl
  },
  SET_VISUAL_PHONE_IMAGE_URL(state: VisualState, phoneImageUrl) {
    state.phoneImageUrl = phoneImageUrl
  },
  SET_VISUAL_MUSIC_IMAGE_URL(state: VisualState, musicImageUrl) {
    state.musicImageUrl = musicImageUrl
  },
  SET_VISUAL_FONT(state: VisualState, font) {
    state.font = font
  },
  SET_VISUAL_HEADER_ELEMENTS_AS_LIST(state: VisualState, headerElementsAsList) {
    state.headerElementsAsList = headerElementsAsList
  },
  SET_VISUAL_HIDE_START_PAGE_GRAPHS(state: VisualState, hideStartPageGraphs) {
    state.hideStartPageGraphs = hideStartPageGraphs
  },
  SET_STICKER_BACKGROUND(state: VisualState, stickerBackground) {
    state.stickerBackground = stickerBackground
  },
  SET_STICKER_SELECTED(state: VisualState, stickersSelected) {
    state.stickersSelected = stickersSelected
  },
}

const actions: ActionTree<VisualState, any> = {}

const getters: GetterTree<VisualState, any> = {
  visualIsDark: (state: VisualState) => state.isDark,
  visualPrimaryColor: (state: VisualState) => state.primaryColor,
  visualBackgroundColor: (state: VisualState) => state.backgroundColor,
  visualArtistHeaderBackground: (state: VisualState) => state.artistHeaderBackground,
  visualArtistProfileBackground: (state: VisualState) => state.artistProfileBackground,
  visualSupportHeaderBackground: (state: VisualState) => state.supportHeaderBackground,
  visualSupportProfileBackground: (state: VisualState) => state.supportProfileBackground,
  visualUserHeaderBackground: (state: VisualState) => state.userHeaderBackground,
  visualUserProfileBackground: (state: VisualState) => state.userProfileBackground,
  visualOwnHeaderBackground: (state: VisualState) => state.ownHeaderBackground,
  visualOwnProfileBackground: (state: VisualState) => state.ownProfileBackground,
  visualHeaderImageUrl: (state: VisualState) => state.headerImageUrl,
  visualLogoImageUrl: (state: VisualState) => state.logoImageUrl,
  visualRadioImageUrl: (state: VisualState) => state.radioImageUrl,
  visualPhoneImageUrl: (state: VisualState) => state.phoneImageUrl,
  visualMusicImageUrl: (state: VisualState) => state.musicImageUrl,
  visualFont: (state: VisualState) => state.font,
  visualTextColor: (state: VisualState) => state.isDark ? '#fff' : '#263451',
  visualButtonTextColor: (state: VisualState) => state.buttonTextColor,
  visualStickerBackground: (state: VisualState) => state.stickerBackground,
  visualParagraphColor: (state: VisualState, g: any) => state.isDark ? state.primaryColor : g.visualTextColor,
  visualStickersSelected: (state: VisualState) => state.stickersSelected,
  visualIsStickerAllowed: (state: VisualState) => state.stickersSelected.length !== 0,
  visualHeaderElementsAsList: (state: VisualState) => state.headerElementsAsList,
  visualHideStartPageGraphs: (state: VisualState) => state.hideStartPageGraphs,
}

export const visualModule: Module<VisualState, any> = {
  state: translationState,
  mutations,
  actions,
  getters,
}
